import React from 'react';
import styled from 'styled-components';
import './_chat.css';

const CustomSpan = styled.span`
    font-size: 1.1em;
`;

const Conversa = (props)=>{
    const { showAvatar, sender } = props
    return(
        <div className={`conversa-container ${sender ? 'right' : ''} ${showAvatar? 'continousChat' : ''}`}>
            <div>
                {
                    !showAvatar ?
                        <img src={props.avatar} alt=""/>
                        :
                        <div style={{paddingRight: 29}}></div>
                }
            </div>
            <div className={`conversa-conteudo ${sender ? 'guest':'non-guest'}`}>
                <CustomSpan>{props.conteudo}</CustomSpan>
            </div>
            <div className="conversa-data">{props.data}</div>
        </div>
    )
}

export default Conversa;


// WEBPACK FOOTER //
// ./src/components/chatview/ChatRow.js